import { useIdentity } from '@vp/auth-react';
import { useContext, useState } from 'react';
import { getRestId, getChatbotToken } from './src-utils-session-storage-utils.js';
import { API_ENDPOINTS } from './src-config-api-config.js';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const useGenerateAcw = () => {
  const { logCustomAttributesNR } = useNRLogging();
  const { authorizationHeader = "", canonicalId = "" } = useIdentity();
  const {
    state: { sessionId }
  } = useContext(ChatbotContext);
  const [summary, setSummary] = useState(null);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const summaryAPI = async () => {
    const payload = {
      order_number: "",
      shopper_id: canonicalId,
      session_id: sessionId || "",
      request_id: getRestId() || ""
    };
    const chatbotToken = getChatbotToken();
    const headers = {
      "Content-Type": "application/json",
      Authorization: authorizationHeader,
      "chatbot-authorization": `Bearer ${chatbotToken}`
    };
    setLoading(true);
    setError(void 0);
    try {
      logCustomAttributesNR("ca-chatbot-api-request", {
        logLevel: "info",
        message: "Starting summary API request",
        apiType: "summaryAPI"
      });
      const response = await fetch(`${API_ENDPOINTS.CHATBOT_BASE_URL()}/summarize-chat-v2`, {
        method: "POST",
        headers,
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        throw new Error(`Fetch failed: ${response.statusText}`);
      }
      const data = await response.json();
      setSummary(data);
      logCustomAttributesNR("ca-chatbot-api-response", {
        logLevel: "info",
        message: "Summary API request successful",
        apiType: "summaryAPI"
      });
      return data;
    } catch (err) {
      const message = err instanceof Error ? err.message : "Unexpected error";
      setError(message);
      console.error("Error in summaryAPI:", message);
      logCustomAttributesNR("ca-chatbot-api-response", {
        logLevel: "error",
        message,
        apiType: "summaryAPI"
      });
    } finally {
      setLoading(false);
    }
  };
  return { summaryAPI, data: summary, error, loading };
};

export { useGenerateAcw };
//# sourceMappingURL=src-hooks-useGenerateAcw.js.map
